"use client";

import { useQuery } from "@tanstack/react-query";
import { getCurrentSessionIdentity } from "@/actions/auth";

export const SESSION_IDENTITY_QUERY_KEY = ["auth", "session-identity"] as const;

export type AuthStatus = "unknown" | "authenticated" | "unauthenticated";

export function useAuthState() {
  const query = useQuery({
    queryKey: SESSION_IDENTITY_QUERY_KEY,
    queryFn: getCurrentSessionIdentity,
    staleTime: 60_000,
    refetchOnMount: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  const authStatus: AuthStatus = query.data
    ? "authenticated"
    : query.isPending || query.isError
      ? "unknown"
      : "unauthenticated";

  return {
    ...query,
    authStatus,
    identity: query.data ?? null,
  };
}
